<template>
  <div class="pc-home-content">
    <div class="content">
      <!-- 最新区块列表 -->
      <block></block>
      <!-- 最新交易列表 -->
      <trade></trade>
    </div>
  </div>
</template>
<script>
import Block from "./ViewBlock";
import Trade from "./ViewTx";
export default {
  components: {
    Block,
    Trade,
  },
};
</script>

<style lang="scss" scoped>
.pc-home-content {
  position: relative;
  background: $white_bg;
  padding-top: 145px;
  .content {
    display: flex;
    justify-content: space-between;
    width: 1250px;
    padding: 0 25px;
    height: 641px;
    margin: 0 auto;
  }
}
</style>
